import {
  Box,
  Center,
  Circle,
  Flex,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import React from "react";
import Custom_Button from "../Button/Custom_Button";
import roboto from "@fontsource/roboto";
import { useState } from "react";
import moment from "moment";
import swAlert from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import * as api from "../../../services/api";

const ProfileTab = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (companyId) {
      api.getCompanyById(companyId).then((res) => {
        if (res.data.data) {
          setFormData((state) => ({
            ...state,
            companyName: res.data.data.companyName,
            gstNumber: res.data.data.gstNumber,
            bio: res.data.data.bio,
            companyAddress:
              res?.data?.data?.companyAddress?.split("_").join(" ") ||
              res?.data?.data?.companyAddress,
            companyEstablished: moment(
              new Date(res.data.data.companyEstablished)
            ).format("YYYY-MM-DD"),
            numberOfEmployees: res.data.data.numberOfEmployees,
            logo: res.data.data.profilePhoto,
            websiteLink: res.data.data.websiteLink,
          }));
        }
      });
    }
    // console.log(formData);
  }, [companyId]);

  const [formData, setFormData] = useState({
    companyName: "",
    gstNumber: "",
    numberOfEmployees: "",
    websiteLink: "",
    companyAddress: "",
    companyEstablished: "",
    bio: "",
    logo: "",
  });

  const changeHandler = (e) => {
    if (e.target.name === "companyEstablished") {
      setFormData((state) => ({
        ...state,
        companyEstablished: moment(new Date(e.target.value)).format(
          "YYYY-MM-DD"
        ),
      }));
    } else {
      setFormData((state) => ({
        ...state,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const submitHandler = async () => {
    try {
      const response = await api.updateCompanyDetails(companyId, formData);
      if (response.status === 200) {
        // swAlert.fire(response.data.message);
        swAlert.fire({
          icon: "success",
          title: response.data.message,
          timer: 1300,
        });
        navigate(-1);
      }
    } catch (error) {
      swAlert.fire({
        icon: "error",
        text: "Something went wrong",
        timer: 1300,
      });
    }
  };

  const discardHandler = async () => {
    navigate(-1);
  };

  return (
    <div>
      <Box>
        <Flex
          flexDirection="column"
          justify="center"
          align="center"
          mt={10}
          py={[0, 0, 3, 3]}
          fontFamily={"Roboto"}
        >
          {/* Profile */}
          <Box>
            <Circle size={40} border="2px solid #6C56FB" overflow="hidden">
              {/* Profile Picture */}
              <img
                src={formData?.logo}
                alt="profile"
                style={{ width: "100%", objectFit: "cover", height: "100%" }}
              />
            </Circle>
          </Box>
          {/* Body */}
          <Flex
            display={["block", "block", "flex", "flex"]}
            align="flex-start"
            gap={20}
            ml={[0,0,-18,-18,-18,-18,-18]}
            w={[
              "98%",
              "98%",
              "fit-content",
              "fit-content",
              "fit-content",
              "fit-content",
            ]}
          >
            {/* First */}

            <Flex flexDir="column" w={480} mt={50} pt={3}>
              <Text
                textAlign="left"
                fontSize={18}
                fontFamily={"Roboto"}
                fontWeight={400}
              >
                Company Name
              </Text>
              <Flex
                border="1px solid #DCDCDC"
                borderRadius={12}
                px={1}
                h={50}
                mt={3}
              >
                <Input
                  variant="unstyled"
                  placeholder="Company Name"
                  ml={3}
                  name="companyName"
                  value={formData.companyName}
                  onChange={changeHandler}
                  autoComplete="off"
                />
              </Flex>
              <Box mt={1}>
                <Text
                  textAlign="left"
                  fontSize={18}
                  fontFamily={"Roboto"}
                  fontWeight={400}
                  mt={3}
                >
                  About Company
                </Text>
                <Textarea
                  placeholder="Write about company"
                  bg="rgba(217, 217, 217, 0.23)"
                  borderRadius={12}
                  fontFamily={"Roboto"}
                  h={300}
                  w={["100%", "100%", "100%", "100%", "100%", "100%", "100%"]}
                  mt={3}
                  name="bio"
                  value={formData.bio}
                  onChange={changeHandler}
                  resize={"none"}
                />
              </Box>
            </Flex>

            {/* Second */}

            <Flex flexDirection="column" my={50} gap={19} py={3}>
              {/* GST & no_of_employee */}
              <Flex flexDir={["column", "column", "row", "row"]} gap={3}>
                {/* GST */}
                <Flex flexDirection="column" gap={3}>
                  <Text
                    textAlign="left"
                    fontSize={18}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                  >
                    GST number
                  </Text>
                  <Flex
                    border="1px solid #DCDCDC"
                    borderRadius={12}
                    px={1}
                    w={["100%", "100%", "100%", 225, 225, 225, 225]}
                    h={50}
                  >
                    <Input
                      disabled
                      variant="unstyled"
                      type="number"
                      placeholder={formData?.gstNumber}
                      ml={2}
                      name="gstNumber"
                      value={formData.gstNumber}
                      onChange={changeHandler}
                      autoComplete="off"
                      fontFamily={"Roboto"}
                    />
                  </Flex>
                </Flex>

                {/*No_of_employees  */}
                <Flex flexDirection="column" gap={3}>
                  <Text
                    textAlign="left"
                    fontSize={18}
                    fontFamily={"Roboto"}
                    fontWeight={400}
                  >
                    Number of employees
                  </Text>
                  <Flex
                    border="1px solid #DCDCDC"
                    borderRadius={12}
                    justify="center"
                    px={1}
                    w={["100%", "100%", "100%", 225, 225, 225, 225]}
                    h={50}
                  >
                    <Input
                      variant="unstyled"
                      placeholder="Enter number"
                      type="number"
                      mx={2}
                      name="numberOfEmployees"
                      value={formData.numberOfEmployees}
                      onChange={changeHandler}
                      autoComplete="off"
                      fontFamily={"Roboto"}
                    />
                    {/* <datalist id="range">
                      <option value="<50">0-50</option>
                      <option value="50-100">50-100</option>
                      <option value="100-200">100-200</option>
                      <option value="200-500">200-500</option>
                      <option value="500-10000">500-10000</option>
                      <option value="10000+">10000+</option>
                    </datalist> */}
                  </Flex>
                </Flex>
              </Flex>

              {/* est date */}
              <Flex flexDirection="column" gap={3}>
                <Text
                  textAlign="left"
                  fontSize={18}
                  fontFamily={"Roboto"}
                  fontWeight={400}
                >
                  Company Establish Date
                </Text>
                {/* Day,month,year */}

                <Flex gap={2} mt={1.5}>
                  {/* Note -height for each input tag is 50 */}
                  <Input
                    placeholder="Established Date"
                    type="date"
                    w="100%"
                    px={5}
                    variant="unstyled"
                    border="1px solid #DCDCDC"
                    borderRadius={12}
                    fontFamily={"Roboto"}
                    textAlign="center"
                    maxLength={2}
                    py={2}
                    h={50}
                    name="companyEstablished"
                    value={formData.companyEstablished}
                    onChange={changeHandler}
                    autoComplete="off"
                  />
                  <datalist id="days">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </datalist>

                  <datalist id="month">
                    <option value="Jan">Jan</option>
                    <option value="Feb">Feb</option>
                    <option value="Mar">Mar</option>
                    <option value="Apr">Apr</option>
                    <option value="May">May</option>
                    <option value="June">June</option>
                    <option value="July">July</option>
                    <option value="Aug">Aug</option>
                    <option value="Sep">Sep</option>
                    <option value="Oct">Oct</option>
                    <option value="Nov">Nov</option>
                    <option value="Dec">Dec</option>
                  </datalist>
                </Flex>
              </Flex>
              {/* website link */}
              <Flex flexDirection="column" gap={3}>
                <Text
                  textAlign="left"
                  fontSize={18}
                  fontFamily={"Roboto"}
                  fontWeight={400}
                >
                  Website Link
                </Text>
                <Flex
                  border="1px solid #DCDCDC"
                  borderRadius={12}
                  mt={1.5}
                  px={1}
                  h={50}
                >
                  <Input
                    variant="unstyled"
                    placeholder="Link here"
                    type="url"
                    ml={2}
                    name="websiteLink"
                    value={formData.websiteLink}
                    onChange={changeHandler}
                    autoComplete="off"
                    fontFamily={"Roboto"}
                  />
                </Flex>
              </Flex>
              <Flex flexDirection="column" gap={19} py={3}>
                {/* address 1 */}
                <Text
                  textAlign="left"
                  fontSize={18}
                  fontFamily={"Roboto"}
                  fontWeight={400}
                >
                  Address
                </Text>
                <Flex
                  border="1px solid #DCDCDC"
                  borderRadius={12}
                  px={1}
                  h={50}
                >
                  <Input
                    variant="unstyled"
                    placeholder="Address Line 1"
                    ml={2}
                    name="companyAddress"
                    value={formData.companyAddress}
                    onChange={changeHandler}
                    autoComplete="off"
                    fontFamily={"Roboto"}
                  />
                </Flex>
              </Flex>
            </Flex>

            {/* Third  */}
          </Flex>

          {/* Buttons */}

          <Flex justify="center" gap={5}>
            <Custom_Button action="Discard" fn={discardHandler} />
            <Custom_Button
              action="Save"
              bg="#6C56FB"
              color="#FFFFFF"
              fn={submitHandler}
            />
          </Flex>
        </Flex>
      </Box>
    </div>
  );
};

export default ProfileTab;
